import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { getFinYears } from '../../redux/actions';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const { user, superUser, token, finyear, customer, error } = useSelector((state) => state?.auth);
  //   const dispatch = useDispatch();
    
  // useEffect(() => {
  //   if (customer?.id && token) {
  //     dispatch(getFinYears());
  //   }
  // }, [superUser, token]);

  useEffect(() => {
    if (token) {
      if (user) {
        setIsAuthenticated(!!token && !!finyear?.id);
      } else if (superUser) {
        setIsAuthenticated(true);
      }
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  }, [token, finyear, user, superUser]);

  useEffect(() => {
    if (error) {
      setIsAuthenticated(false);
    }
    setLoading(false);
  }, [error])

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook to use auth context
export const useAuth = () => useContext(AuthContext);
